var map = {
	"./register-input-data-1.png": 72813,
	"./register-input-data-1__en.png": 27621,
	"./register-input-data-2.png": 91190,
	"./register-input-data-2__en.png": 79821,
	"./register-input-step-flow-1.png": 68706,
	"./register-input-step-flow-1__en.png": 80361,
	"./register-input-step-flow-2.png": 82713,
	"./register-input-step-flow-2__en.png": 62094,
	"./register-input-step-flow-3.png": 50608,
	"./register-input-step-flow-3__en.png": 52483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96606;